import { render, staticRenderFns } from "./ReviewsGrid.vue?vue&type=template&id=68862cd9&scoped=true&"
import script from "./ReviewsGrid.vue?vue&type=script&lang=ts&"
export * from "./ReviewsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsGrid.vue?vue&type=style&index=0&id=68862cd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68862cd9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewOverview: require('/opt/build/repo/apps/shop/components/ReviewOverview.vue').default,ReviewGallery: require('/opt/build/repo/apps/shop/components/ReviewGallery.vue').default,Reviews: require('/opt/build/repo/apps/shop/components/Reviews.vue').default})
